import { fontSizes } from "../../constants/constants";
import { useAuth } from "../../context/authContext";
import textWeight from "../../utils/textWeight";
import Btn from "../btn";
import FormHeading from "../formHeading";

const LogOut = ({ closePopup }) => {
  const { logout } = useAuth();
  const { TextWeight } = textWeight();
  return (
    <div className="fixed inset-0 backdrop-blur-md px-8 sm:px-24 bg-[#707070] bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-secondary rounded-[50px] p-10 text-center w-full sm:w-[50%] max-h-[90vh] overflow-y-auto hide-scrollbar">
        <FormHeading title="Are You Sure ?" />
        <div className="flex justify-center items-center flex-col sm:flex-row flex-wrap xl:flex-nowrap sm:mt-9 mb-5 gap-2 sm:gap-5 lg:gap-8">
          <Btn
            onClick={() => {
              logout();
            }}
            type={"button"}
            isprimary={false}
            weight={TextWeight.Raleway_SemiBold}
            textSize={fontSizes.h18}
            text={"Logout"}
            color="text-white hover:text-primary"
            bgColor={
              "bg-primary hover:bg-white hover:border-primary border-transparent"
            }
          />
          <Btn
            type={"button"}
            weight={TextWeight.Raleway_SemiBold}
            textSize={fontSizes.h18}
            text={"Cancel"}
            color="text-primary hover:text-white"
            bgColor={
              "bg-white hover:bg-primary hover:border-transparent border-primary"
            }
            onClick={closePopup}
          />
        </div>
      </div>
    </div>
  );
};
export default LogOut;
